<template>
  <div class="home">
    <Carousel/>
    <!-- <div class="bannerWrap" ref="bannerRef">
      <div class="mainLogoBox">
        <div class="sponsorWrap">
          <ul>
            <li><a href="https://www.velobici.cc/zh" title="" target="_blank"><img src="@/assets/images/logo_5.png"></a></li>
            <li><a href="" title="" target="_blank"><img src="@/assets/images/logo_1.png"></a></li>
            <li><a href="" title="" target="_blank"><img src="@/assets/images/logo_2.png"></a></li>
            <li><a href="https://quoc.cc/" title="" target="_blank"><img src="@/assets/images/logo_3.png"></a></li>
            <li><a href="https://www.amd.com/zh-hant/processors/ryzen" title="" target="_blank"><img src="@/assets/images/logo_4.png"></a></li>
            <li><a href="" title="" target="_blank"><img src="@/assets/images/logo_6.png"></a></li>
          </ul>
        </div>
        <div class="sponsorWrap">
          <ul>
            <li><a href="" title="" target="_blank"><img src="@/assets/images/logo_12.png"></a></li>
            <li><a href="" title="" target="_blank"><img src="@/assets/images/logo_18.png"></a></li>
            <li><a href="" title="" target="_blank"><img src="@/assets/images/logo_13.png"></a></li>
            <li><a href="" title="" target="_blank"><img src="@/assets/images/logo_14.png"></a></li>
            <li><a href="" title="" target="_blank"><img src="@/assets/images/logo_16.png"></a></li>
            <li><a href="" title="" target="_blank"><img src="@/assets/images/logo_15.png"></a></li>
            <li><a href="" title="" target="_blank"><img src="@/assets/images/logo_17.png"></a></li>
          </ul>
        </div>
        <div class="sponsorWrap">
          <ul>
            <li><a href="" title="" target="_blank"><img src="@/assets/images/logo_7.png"></a></li>
            <li><a href="" title="" target="_blank"><img src="@/assets/images/logo_8.png"></a></li>
            <li><a href="" title="" target="_blank"><img src="@/assets/images/logo_9.png"></a></li>
            <li><a href="" title="" target="_blank"><img src="@/assets/images/logo_10.png"></a></li>
            <li><a href="" title="" target="_blank"><img src="@/assets/images/logo_11.png"></a></li>
          </ul>
        </div>
        
      </div>
    </div> -->
    
    <div class="videoWrap row g-3" ref="gotoVideo">
      <h2><span>雙平台直播，追蹤賽事不漏接！</span></h2>
      <div class="videoBox">
        <a :href="getVideo.videoYtUrl" target="_blank">
          <div class="youTubeImg">
            <img :src="getVideo.videoYtImg" alt="賽事直播">
          </div>
        </a>
        <a :href="getVideo.videoTtUrl" target="_blank">
          <div class="youTubeImg">
            <img :src="getVideo.videoTtImg" alt="賽事直播">
          </div>
        </a>
      </div>
    </div>
    <div class="bgFull">
      <div class="noticeWrap">
        <div class="noticeBox row g-3">
          <h2><span>最專業、熱情的播報團隊！</span></h2>
          <div class="col-md-4 themeBox">
            <div class="card">
              <img src="static/images/host_1.png" class="card-img-top" style="max-width: max-content; margin: 0 auto; padding: 20px;">
              <div class="card-body">
                <h5 class="card-title">主持人</h5>
                <p class="card-text ti">單車小D 揪愛騎</p>
                <div class="card-text info">
                  <ul>
                    <li>
                      <strong>記者會主持：</strong>
                      <ul>
                        <li>太陽公主號X歌詩達威尼斯號嘉年華記者會</li>
                        <li>參山騎旅二林水深度農遊單車行</li>
                        <li>LAVA山水鐵人</li>
                      </ul>
                    </li>
                    <li>
                      <strong>活動賽事領騎主持：</strong>
                      <ul>
                        <li>欣單車主辦：施巴欣騎天台中大坑小三元、DIZO fun暑假小D宇老約騎、南庄Z字道單車活動、迎春納庫環湖石門霸主、粉紅欣騎天北113趣味單車PK大對決</li>
                        <li>LAVA鐵人公司：來Bike吧！去屏東走走(南北場)、大鵬灣鐵人賽、環屏東自行車二日挑戰賽</li>
                      </ul>
                    </li>
                    <li>
                      <strong>其他LIVE節目主持：</strong>
                      <ul>
                        <li>神遊IN THE HOUSE-旅行發摟ME節目主持人(共錄製37集)</li>
                        <li>2022Whiizu武嶺盃電競初賽/決賽主持人</li>
                        <li>2022台灣盃國際自由車電競爭霸賽主持人</li>
                      </ul>
                    </li>
                  </ul>
                </div>
                <p class="card-text bg-light say">給選手們的話：虛擬騎乘滿足現實中的缺憾！不多說上卡帥一波吧！</p>
                <p class="card-text bg-light" style="transform: rotate(0);">
                  <a href="https://www.facebook.com/bike.little.D" class="stretched-link">粉專連結</a>
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-4 themeBox">
            <div class="card">
              <img src="static/images/host_2.png" class="card-img-top" style="max-width: max-content; margin: 0 auto; padding: 20px;">
              <div class="card-body">
                <h5 class="card-title">主播</h5>
                <p class="card-text ti">李4瘋單車</p>
                <div class="card-text info">
                  <ul>
                    <li>
                      <strong>公路車簡歷：</strong>
                      <ul>
                        <li>108 桃園市長盃M25 分6</li>
                        <li>109 桃園市長盃M25 分2</li>
                        <li>109 玉井 新玉門關 市民組M20 分1</li>
                        <li>109 小櫻桃北113 M30分5</li>
                        <li>109 新經典玉門關 菁英組總6 M25 分1</li>
                        <li>109 海鷗團體 第四名</li>
                        <li>111 扶輪盃大屯山登山王M30 分組第6</li>
                        <li>111 桃園市長盃M30分組第二</li>
                        <li>111 FTL梅南橋TTT 冠軍</li>
                        <li>111 CYTO大鞍爬坡 亞軍</li>
                        <li>111 taiwan kom summer M30分組 第二</li>
                      </ul>
                    </li>
                  </ul>
                </div>
                <p class="card-text bg-light say">給選手們的話：祝福各位選手都能順利的將平常的訓練成果發揮出來！每一場都不留遺憾的騎完，勝負的結果我們不能決定，但是全力以赴的過程可以！</p>
                <p class="card-text bg-light" style="transform: rotate(0);">
                  <a href="https://www.facebook.com/bunzlee4" class="stretched-link">粉專連結</a>
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-4 themeBox">
            <div class="card">
              <img src="static/images/host_3.png" class="card-img-top" style="max-width: max-content; margin: 0 auto; padding: 20px;">
              <div class="card-body">
                <h5 class="card-title">賽評</h5>
                <p class="card-text ti">張壽生</p>
                <div class="card-text info">
                  <ul>
                    <li>
                      <strong>公路車簡歷：</strong>
                      <ul>
                        <li>1989年全國公路錦標賽冠軍</li>
                        <li>1989年亞洲錦標賽一百公里團隊第四名</li>
                        <li>1990年代亞奧運培訓隊選手</li>
                        <li>1993年台灣區運會領先計分賽冠軍</li>
                        <li>1993年 參加世界錦標賽</li>
                        <li>1994年普吉島鐵人三項24歲組第六名</li>
                        <li>1995年赴美參加完整賽季</li>
                        <li>1996年環台賽高雄-台東站單站第十名</li>
                        <li>2000年環沖繩賽市民組120公里第五名</li>
                        <li>台灣區運會多面團體賽金、銀牌</li>
                      </ul>
                    </li>
                    <li>
                      <strong>新聞媒體/車評經歷</strong>
                      <ul>
                        <li>多場賽事國際新聞總監(環台賽、崇明島世界杯、環中賽、環海南島、環青海湖)</li>
                        <li>多次擔任環法大賽、環台大賽車評</li>
                      </ul>
                    </li>
                    <li>
                      <strong>裁判經歷</strong>
                      <ul>
                        <li>2021~2022 台灣盃國際自由車電競賽 賽事總監/裁判長</li>
                        <li>2021~2022  全國自由車電競賽 賽事總監/裁判長</li>
                      </ul>
                    </li>
                  </ul>
                </div>
                <p class="card-text bg-light say">給選手們的話：每一場比賽的全力以赴，都在解鎖邁向卓越的養分。</p>
                <p class="card-text bg-light" style="transform: rotate(0);">
                  <a href="https://www.facebook.com/bikemangreg" class="stretched-link">粉專連結</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div ref="gotoApply">
        <component :is="applyComponent" @emit-component="changeComponent"></component>
      </div>
      <!-- <Apply ref="gotoApply" @emit-component="changeComponent" @emit-form="setForm">
        <component :is='applyComponent'/>
      </Apply> -->

      <div class="playerWrap" ref="gotoPlayer">
        <div class="blur">
          <div class="playerBox row g-3">
            <h2><span>選手名單</span></h2>
            <div class="col-md-6" v-for="cups in players" :key="cups.id">
              <table class="table table-bordered table-light align-middle">
                <tbody>
                  <template v-for="(cup, c) in cups.second">
                    <tr v-for="(gro, i) in cup.third" :key="gro">
                      <td v-if="c == 0 && i == 0" :rowspan="getThird">{{ cups.title }}</td><!-- 第一列 --><!-- :rowspan 是用 getters 計算 players 的 "third" 總共有幾個 -->
                      <td v-if="c == 0 && i == 0" :rowspan="getThird / 2">{{ cup.group }}</td><!-- 第二列，不知道為啥用 gro.length 會出錯算出 18 跟 3 -->
                      <td v-if="c == 1 && i == 0" :rowspan="getThird / 2">{{ cup.group }}</td><!-- 第二列 -->
                      <td>{{ gro.name }}</td><!-- 第三列 -->
                      <!-- <td>C:{{ c }} I:{{ i }}</td> --><!-- 用這來看 c i 數字 -->
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>

            <!-- <div class="col-md-6">
              <table class="table table-bordered align-middle border-golden">
                <tbody>
                  <tr>
                    <td rowspan="8">男人盃</td>
                    <td rowspan="4">A組</td>
                    <td>參賽者</td>
                  </tr>
                  <tr>
                    <td>參賽者</td>
                  </tr>
                  <tr>
                    <td>參賽者</td>
                  </tr>
                  <tr>
                    <td>參賽者</td>
                  </tr>
                  <tr>
                    <td rowspan="4">B組</td>
                    <td>參賽者</td>
                  </tr>
                  <tr>
                    <td>參賽者</td>
                  </tr>
                  <tr>
                    <td>參賽者</td>
                  </tr>
                  <tr>
                    <td>參賽者</td>
                  </tr>
                </tbody>
              </table>
            </div> -->
          </div>
        </div>
        <div class="playerBg">
          <img src="@/assets/images/bg_4.jpg" data-depth="0.60" ref="playerPic">
        </div>
      </div>
      
      <div class="mapWrap">
        <div class="noticeBox row g-3">
          <div class="col-md-12 themeBox">
            <div class="word">
              <div v-for="sponsor in sponsors" :key="sponsor.id">
                <h2><span>{{sponsor.title}}</span></h2>
                <div class="footLogo">
                  <a v-for="item in sponsor.logo" :key="item.srcNum" :href="item.link" :title="item.name">
                    <img :src="imageLogo(item.srcNum)">
                  </a>
                </div>
              </div>
              
            </div>
          </div>
        </div>
        <div class="noticeBox row g-0 position-relative">
          <div class="col-md-6 mb-md-0 p-md-4">
            <img src="@/assets/images/map.png" class="w-100" style="width: auto; max-width: 600px;">
          </div>
          <div class="col-md-6 p-4">
            <h2 class="mt-0" style="text-align: left;">曜越單車旗艦館</h2>
            <p style="text-align: left;">
              地址：台北市內湖區瑞光路100號<br>
              門市電話：(02) 27901300<br>
              營業時間：周一至周日11:00–20:00
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from "@/components/HelloWorld.vue";
import Carousel from '@/components/Carousel.vue'
import Consent from '@/components/Consent.vue'
import Apply from '@/components/Apply.vue'
import { Fancybox } from '@fancyapps/ui'
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import { defineComponent, computed, reactive } from "vue"
import { useHead } from "@vueuse/head"
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default {
  name: "HomeView",
  components: {
    Carousel,
    Apply,
    Consent,
  },
  inject: ['emitter'], // 內層元件用Inject的方式把emitter讀進來
  data() {
    return {
      // form: {
      //   username: '',
      //   phone: '',
      //   email: '',
      //   address: '',
      //   idcard: '',
      //   birthdate: '',
      //   weight: '',
      //   height: '',
      //   ftp: '',
      // },
      applyComponent: 'Apply', // 一開始是要顯示 Apply 這個 Component，點了我要報名才會觸發 emit 改成 Consent
      idTopDistance: [],
    }
  },
  methods: {
    ...mapActions(['getPlayers', 'getSponsor']),

    changeComponent(item) {
      console.log('changeComponent', item)
      this.applyComponent = item
    },
    setForm(item) {
      console.log(item)
    },
    // ...mapActions(['getPlayers']),
    // playerApply() {
    //   const order = this.form
    //   const url = `http://eventapi.ttelgaming.com.tw/ajax_ttbikecomp.php`;

    //   const formData = new FormData()
    //   formData.append('username', this.form.username)
    //   formData.append('phone', this.form.phone)
    //   formData.append('email', this.form.email)
    //   formData.append('address', this.form.address)
    //   formData.append('idcard', this.form.idcard)
    //   formData.append('birthdate', this.form.birthdate)
    //   formData.append('weight', this.form.weight)
    //   formData.append('height', this.form.height)

    //   this.$http.post(url, formData)
    //   .then(rs => {
    //     console.log('表單報名:', rs)
        
    //   })
    // }
    imageLogo(item) {
      return `./static/images/logo/logo_${item}.png`
    },
    isMobile() { 
      return ('ontouchstart' in document.documentElement); 
    },
    paraWrapFunc() {
      const playerPicSrc = this.$refs.playerPic.src
      const playerPic = this.$refs.playerPic
      const gotoPlayer = this.$refs.gotoPlayer
      const perLoadList = new Image();
      perLoadList.src = playerPicSrc;
      perLoadList.onload = () => { // 確認等 load 完圖片才執行，不然會抓不到圖片高度(offsetHeight 會為 0)
        const paraWrap = gsap.timeline({
          scrollTrigger: {
            trigger: gotoPlayer,
            start: "top center",
            end: "bottom center",
            scrub: 1,
            invalidateOnRefresh: true
          }
        });
        const h = playerPic.offsetHeight
        const n = playerPic.dataset.depth;
        let movement = -(h * n) / 6;
        paraWrap.to(playerPic, {
          y: movement,
          ease: "none"
        });
      };
    },
    scrollToId() {
      const findRefs = Object.keys(this.$refs).filter(item => { // 遍歷所有 ref 再篩選出有 goto 的 ref
        return item.match(/^goto/g)
      })
      for(let i = 0; i < findRefs.length; i++) {
        const linkId = this.$refs[findRefs[i]]; // 這邊要記得加上[i]
        let topDistance = linkId.offsetTop; // 網頁頂端到這ref元素的高度
        this.idTopDistance.push(topDistance)
        console.log('idTopDistance', this.idTopDistance)
      }
    },
  },
  computed: {
    ...mapGetters(['getThird']),
    ...mapState({
      players: 'players',
      sponsors: 'sponsor',
      form: 'form', // 為了把 data 的 form 寫到 vuex(先從 vuex 取得 state 資料讓下面 get)
      // form: state => state.form,
    }),
    
    getVideo() {
      return {
        videoYtImg: `./static/images/video_1.jpg`,
        videoTtImg: `./static/images/video_2.jpg`,
        videoYtUrl: `https://www.youtube.com/channel/UCdDW1nhZ7vHSrYSjR6j-VOA`,
        videoTtUrl: `https://www.facebook.com/thermaltakebicycle`
      }
    }
  },
  created() {
    this.getPlayers();
    this.getSponsor();
    // this.playerApply();
  },
  mounted() {
    // ------- 分頁式用下面這種方式(但不是很OK，先暫時這樣了) -------
    this.scrollToId();
    this.emitter.on('emitgotoId', (data) => { //搞了很久，在組件NavBar點擊menu會跳到首頁並直接連到ref[data]的地方
      this.clickBtn = data;
      window.scrollTo(0, this.idTopDistance[data]);
    })

    // ------- 一頁式可以用下面這種方式 -------
    // console.log('遍歷所有 ref 轉成陣列', Object.keys(this.$refs), Object.values(this.$refs), Object.entries(this.$refs))
    // const findRefs = Object.keys(this.$refs).filter(item => { // 遍歷所有 ref 再篩選出有 goto 的 ref
    //   return item.match(/^goto/g)
    // })
    // console.log('findRef', findRefs)
    // this.emitter.on('emitgotoId', data => { // 接收 header emit 過來的數字
    //   const gotoId = this.$refs[findRefs[data]]; // 帶上數字找出是陣列中的哪一個 ref
    //   // let d = gotoId.offsetTop + gotoId.offsetHeight; // 網頁頂端到這ref元素的高度 + 在加上它本身區塊的高度
    //   let d = gotoId.offsetTop // 網頁頂端到這ref元素的高度
    //   console.log('emitgotoId', d)
    //   window.scrollTo(0, d);
    // })

    if(!this.isMobile()) { // 再手機用這效果好像都會自己滾動到頂端，所以偵測是否為手機
      console.log('不是行動裝置')
      this.paraWrapFunc();
    } else {
      console.log('是行動裝置')
    }
    

    Fancybox.bind('[data-fancybox="gallery"]', {
      Thumbs: false,
      Toolbar: false,
      Image: {
        zoom: false,
        click: false,
        wheel: 'slide'
      }
    })
  },
};
</script>

<style>
@import "@fancyapps/ui/dist/fancybox.css";
.noticeBox.position-relative {
  justify-content: center;
  align-items: center;
  max-width: 1500px;
  padding: 0 20px 90px;
  background-image: url(@/assets/images/i_road_bg.png);
  background-repeat: no-repeat;
  background-position: center bottom;
  background-size: 100%;
}
body {
  font-size: var(--text-base-size, 1rem);
}
.card {
  background-color: transparent;
  border: 0;
}
.card-title {
  font-size: 30px;
  text-align: center;
}
.card-text {
  padding: 0 20px;
}
.themeBox .card-text.ti {
  text-align: center;
  font-size: 25px;
  padding: 2%;
}
.card-text.bg-light {
  text-align: center;
  padding: 10px;
}
.card-text.bg-light.say {
  text-align: left;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
  border-radius: 10px;
  padding: 15px;
}
.themeBox .card-text.info ul {
  list-style: none;
  padding: 0;
}
.themeBox .card-text.info ul li > ul li {
  padding-left: 20px !important;
  background-image: url(@/assets/images/icon_1.png);
  background-position: 0 50%;
  background-repeat: no-repeat;
}

.bannerWrap {
  position: relative;
  width: 100%;
  margin-top: 90px;
  /* height: 700px; */
  /* height: 100vh; */
  overflow: hidden;
}
.mainLogoBox {
  /* position: absolute; */
  width: 70%;
  margin: 0 auto;
  padding: 0 20px;
  display: block;
  top: 50%;
  left: 50%;
  /* transform: translateX(-50%) translateY(-50%); */
  z-index: 1;
  /* margin: -135px 0 0 -520px; */
}
.mainLogo {
  max-width: 100%;
  display: block;
  margin: 0 auto;
}
.mainBan {
  bottom: 0;
  left: 50%;
  min-height: 100vh;
  min-width: 100vw;
  -o-object-fit: cover;
  object-fit: cover;
  position: absolute;
  top: 0;
  /* transform: translateX(20%); */
  transform: translateX(-50%);
  width: auto;
  z-index: 0;
}
.organizer {
  font-size: 30px;
  text-align: center;
  font-weight: bold;
  padding: 50px 0;
}

img {
  width: auto;
}
h2 {
  font-size: var(--text-xl);
  text-align: center;
  margin: 30px 0;
}
h3, h4 {
  text-align: center;
  margin: 30px 0;
}
h2 span {
  display: inline-block;
  padding: 0 20px;
  vertical-align: middle;
  text-shadow: hsl(0deg 0% 100% / 70%) 1px 1px 0;
}
/* h2::before, h2::after {
  display: inline-block;
  vertical-align: middle;
  content: "";
  background-color: #c9bb90;
  width: 80px;
  height: 2px;
  border-radius: 100px;
  transition: all .5s ease;
  transition-delay: .3s;
} */
.txt {
  /* font-size: var(--font-size-sub-ti); */
  font-size: var(--text-base-size, 1rem);
  text-align: center;
  margin-top: 0 !important;
}
.note {
  color: #202020;
  font-size: 13px;
  font-weight: normal;
  display: block;
  padding: 5px 0;
}
.blur {
  backdrop-filter: blur(5px);
}
.videoWrap {
  position: relative;
  width: var(--width-normal);
  /* max-width: var(--max-width-normal); */
  /* margin: 90px auto; */
  margin: 0 auto;
  /* padding: 90px 0 0; */
  padding: 50px 0 0;
  display: flex;
  background-image: url(@/assets/images/i_road_bg.png);
  background-repeat: no-repeat;
  background-position: center bottom;
  background-size: 100%;
  /* padding: 0 50px; */
}
.videoBox {
  display: flex;
  max-width: 1600px;
  margin: 0 auto;
}
.videoWrap a {
  /* display: inline-block; */
  width: 50%;
  /* padding: 0 3%; */
}
.youTubeImg {
  /* border-radius: 20px; */
  overflow: hidden;
  /* border: 5px solid #ffffff; */
  /* box-shadow: inset 0px 1px 0px hsla(var(--color-white-h), var(--color-white-s), var(--color-white-l), 0.15), 
              0px 1px 3px hsla(var(--color-primary-darker-h), var(--color-primary-darker-s), var(--color-primary-darker-l), 0.25), 
              0px 2px 6px hsla(var(--color-primary-darker-h), var(--color-primary-darker-s), var(--color-primary-darker-l), 0.1), 
              0px 6px 10px -2px hsla(var(--color-primary-darker-h), var(--color-primary-darker-s), var(--color-primary-darker-l), 0.25); */
}
.videoWrap img {
  display: block;
}
.videoIcon {
  position: absolute;
  width: 180px;
  height: 180px;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
  /* margin: -100px 0 0 -100px; */
  /* line-height: 200px; */
  text-align: center;
  /* -webkit-transform: scale(0);
  -ms-transform: scale(0);
  transform: scale(0); */
  border-radius: 99em;
  -moz-border-radius: 99em;
  -webkit-border-radius: 99em;
  -o-border-radius: 99em;
  -webkit-transition: all 0.2s linear;
  transition: all 0.2s linear;
  font-size: var(--text-lg);
  overflow: hidden;
  background: var(--linear-gradient-normal);
  color: var(--color-normal);
  text-shadow: hsl(0deg 0% 100% / 70%) 1px 1px 0;
}
.videoIcon span {
  position: absolute;
  width: 100%;
  top: 50%;
  left: 50%;
  padding: 0 15%;
  transform: translateX(-50%) translateY(-50%);
  z-index: 1;
}

.bgFull {
  /* background-image: url(@/assets/images/bg_1.jpg); */
  background-size: 100%;
  background-repeat: no-repeat;
  background-color: #f5f5f5;
}

.proSpecCont .rwdTable, .cartTotalTab .rwdTable {
	width:100%;
	border-collapse:collapse;
  border-spacing:0;
}
.cartTotalTab, .playerBox {
	width: 100%;
  max-width: var(--max-width-normal);
  /* padding: 5% 50px; */
  padding: 80px 50px;
	margin: 0 auto;
}
.playerWrap {
  position: relative;
  /* background-image: url(@/assets/images/bg_3.jpg); */
  background-size: cover;
  background-repeat: no-repeat;
  /* padding: 8% 50px; */
  /* height: 70vh; */
  overflow: hidden;
}
.playerWrap .blur {
  padding: 0 50px;
  /* padding: 8% 50px; */
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 2;
}
.playerBox {
  max-width: var(--max-width-large);
  /* background-color:rgba(255, 255, 255, 0.6); */
  /* padding: 100px 80px; */
  padding: 0 80px;
  /* box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24); */
  /* border: 1px solid #c5c5c5;
  backdrop-filter: blur(5px); */
  border-radius: 20px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
}
.playerBg {
  display: flex;
  height: 70vh;
  justify-content: center;
  overflow: hidden;
  position: relative;
  width: 100%;
}
.playerBg img {
  bottom: 0;
  height: 100%;
  left: 50%;
  min-height: 100vh;
  min-width: 100vw;
  -o-object-fit: cover;
  object-fit: cover;
  /* position: absolute; */
  top: 0;
  /* transform: translateX(-50%); */
  width: auto;
  z-index: 1;
}
@media only screen and (max-width: 767px) {
	.playerBg {
		min-height: 1000px;
	}
  .playerBox {
    padding: 0;
  }
  h2::before, h2::after {
    display: none;
  }

  .videoIcon {
    overflow: hidden;
    font-weight: bold;
    background: transparent;
  }
  .videoIcon.btn--primary {
    box-shadow: none;
  }
  .btn--primary:hover {
    background: transparent !important;
    box-shadow: none;
  }
}
.noticeWrap {
  /* background-image: url(@/assets/images/i_zone_2_bg.jpg); */
  background-size: cover;
  background-repeat: no-repeat; 
  background-position: center bottom;
  /* -webkit-clip-path: polygon(0 0, 100% 0, 100% 100%, 0 90%);
  clip-path: polygon(0 0, 100% 0, 100% 100%, 0 90%); */
  background-color: #FFF;
}
.noticeBox {
  max-width: var(--max-width-large);
  margin: 0 auto;
  /* padding: 100px 80px; */
  padding: 80px 20px;
}
.cartTotalTab .rwdTable td {
	font-size:20px;
}
.cartTotalTab .rwdTable td:nth-child(2) {
	text-align:right;
	color:#ff3a3a;
}
.cartTotalTab .rwdTable tr.totalBg {
	background:-moz-linear-gradient(top, #ff7473 0%, #ff3a3a 100%);
	background:-webkit-linear-gradient(top, #ff7473 0%, #ff3a3a 100%);
	background:linear-gradient(to bottom, #abacac 0%, #909090 100%);
	filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff7473', endColorstr='#ff3a3a',GradientType=0);
	/* background-color:#ff3a3a; */
}
.cartTotalTab .rwdTable td {
	padding:15px 25px;
	line-height:25px;
	color:#202020;
}
.cartTotalTab .rwdTable tr.totalBg td {
	color:#FFF;
}
.cartTotalTab .rwdTable td.couponBox div {
	margin-left:5px;
	float:right;
}
.cartTotalTab .rwdTable td.couponBox div:first-child input {
	background-color:#ff3a3a;
	-moz-border-radius:2px;
	-webkit-border-radius:2px;
	border-radius:2px;
	text-align:center;
	line-height:20px;
	font-size:12px;
	padding:2px 5px;
	color:#FFF;
	border:0;
	cursor:pointer;
	-webkit-transition:.2s ease-in-out;
	transition:.2s ease-in-out;
}
.cartTotalTab .rwdTable td.couponBox div:first-child input:hover {
	background-color:#4c4c4c;
}
.cartTotalTab .rwdTable td .note{ color:#202020; font-size:13px; font-weight:normal; display:block;}
.cartTotalTab .rwdTable td label {
	color:#202020;
}
.cartTotalTab .rwdTable td label span {
	color:#ff3a3a;
}
.cartTotalTab.row {
  margin: 0 auto;
}
.control .qty, .rwdTable tr input, .rwdTable tr select {
  height: 40px;
  width: 40px;
  /* float: left; */
  display: inline-block;
  vertical-align: middle;
  border-top-right-radius: 0;
  -webkit-border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  -webkit-border-bottom-right-radius: 0;
  border: 1px solid #ddd;
  font-size: 14px;
  text-align: center;
}
.rwdTable tr input, .rwdTable tr select {
  width: auto;
}
input[type=number]::-webkit-outer-spin-button,
input[type=number]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.headCartTable {
  line-height: 23px;
  color: #c5c5c5;
  font-size: 13px;
  font-weight: normal;
}
.rwdTable button {
  background: linear-gradient(to bottom,#cfcfcf 0%,#909090 100%);
  padding: 8px;
  width: 100%;
  border: 0;
  border-radius: 99px;
}
.rwdTable button.del {
  width: 25px;
  height: 25px;
  line-height: 25px;
  padding: 0;
  overflow: hidden;
}
.rwdTable img {
  max-width: 100px;
}
.tabsBody.cart {
  margin-bottom: 70px;
}
.tabsBody.cart h2 {
  min-height: 30px;
  color: #202020;
  font-size: 25px;
  line-height: 30px;
  padding: 10px;
}
.cartBtnBox {
  margin: 30px 0;
}
.btnCarAgree {
  text-align: center;
}
.btnCarAgree button, .btnCarAgree a {
  font-size: var(--text-lg);
}

/* .themeBox h2 {
  float: left;
  font-size: 35px;
  margin: 3%;
  margin: 1%;
  line-height: 45px;
} */
.themeBox h2::before, .themeBox h2::after {
  content: none;
}
.themeBox .word {
	/* float: left; */
  width: 100%;
  /* max-width: 1200px; */
  margin: 0 auto;
  letter-spacing: 1px;
  /* padding: 1% 3%; */
  /* margin: 2% 0; */
  /* border-left: 1px solid #c9bb90; */
}
.themeBox .ti {
  font-size: var(--font-size-sub-ti);
  border-bottom:1px solid #c9bb90;
  padding: 5%;
}
.themeBox .info ul {
  list-style: decimal;
  /* padding: 3% 5%;
  margin: 0 3%; */
  padding: 2% 2%;
  margin: 0 2%;
}
.themeBox .info ul li {
  /* padding: 3% 0 !important; */
  padding: 15px 0 !important;
}

.awardsWrap {
  width: 100%;
  /* background: linear-gradient(to bottom, #fafafa 0%, #d6d6d6 100%); */
  /* background: linear-gradient(to bottom, #f1f1f1 0%, #e5e5e5 100%); */
}
.awardsAll {
  display: block;
  margin: 0 auto;
  width: auto;
}
.awardsBox, .mapBox {
  width: 100%;
  padding: 100px 80px;
  overflow: hidden;
  max-width: 2200px;
  margin: 0 auto;
}
.awardsBox .themeBox {
  /* clip-path: polygon(0 0, 100% 0%, 80% 100%, 0% 100%); */
  -webkit-transition: 0.4s ease-in-out;
  transition: 0.4s ease-in-out;
  -webkit-transform: skewX(-3deg);
  transform: skewX(-3deg);
  overflow: hidden;
  border-left: 1px solid #c9bb90;
  padding: 0 20px;
}
/* .awardsBox .themeBox .info ul {
  list-style: disc;
} */
.awardsBox .themeBox.champion {
  border: 0;
  margin: 0 0 50px;
}
.awardsBox .themeBox.champion .ti {
  text-align: center;
  font-size: var(--text-lg);
  padding: 2%;
  /* background-color: #f6f6f6; */
}
.awardsBox .themeBox.champion .info ul li {
  padding: 2% 0 !important;
}
.awardsBox .awardBg {
  /* min-height: 500px; */
  background-size: 100%;
  background-repeat: no-repeat; 
  background-position: right bottom;
}
.awardsBox .awardBg.one .info {
  min-height: 700px;
  /* background-image: url(@/assets/images/awards_1.jpg); */
  background-size: contain;
  background-repeat: no-repeat; 
  background-position: right bottom;
  font-size: 25px;
}
@media only screen and (max-width: 1900px) {
  .awardsBox .awardBg.one .info {
    min-height: auto;
    /* background-image: url(@/assets/images/awards_1.jpg); */
    background-size: 50%;
    background-position: right top;
  }
}
@media only screen and (max-width: 1200px) {
  .awardsBox .awardBg.one .info {
    padding-bottom: 70%;
    background-size: contain;
    background-position: right bottom;
  }
}
@media only screen and (max-width: 767px) {
  .awardsBox .themeBox {
    border-left: 0;
  }
}

.mapWrap {
  /* background-image: url(@/assets/images/i_zone_2_bg.jpg); */
  background-size: cover;
  background-repeat: no-repeat; 
  background-position: center bottom;
  text-align: center;
  background: linear-gradient(to bottom, #ffffff 0%, #e5e5e5 100%);
}
.footLogo {
  padding: 5%;
  width: 100%;
  text-align: center;
}
.footLogo a {
  display: inline-block;
  width: 50%;
}
.footLogo img {
  width: auto;
  padding: 50px 20px;
  /* max-height: 50px; */
}

.sponsorWrap {
  width: 100%;
  max-width: var(--max-width-large);
  /* padding: 70px 0 0; */
  margin: 0 auto;
  overflow: hidden;
}
.sponsorWrap ul {
  display: flex;
  justify-content: center;
  align-items: center;
	justify-content: space-around;
  list-style: none;
  padding: 0;
  margin: 0;
}
.sponsorWrap ul li {
  /* padding: 0 20px; */
  padding: 20px;
  display: inline-block;
}
@media only screen and (max-width: 767px) {
  .mainLogoBox {
    width: 100%;

    position: relative;
    top: 0;
    left: 0;
    transform: translateX(0) translateY(5%);
  }
  .bannerWrap {
    height: auto;
  }
  .sponsorWrap ul {
    display: block;
  }
  .sponsorWrap ul li {
    padding: 20px;
    width: 50%;
    display: inline-block;
  }
}
#footer {
  text-align: center;
  width: 100%;
  font-size: 13px;
  line-height: 20px;
  padding: 20px 0;
  text-shadow: hsl(0deg 0% 100% / 70%) 1px 1px 0;
  /* background: linear-gradient(to bottom, #fafafa 0%, #d6d6d6 100%); */
  background-color: #e5e5e5;
  border-top: 1px solid #cbcbcb;
}
</style>
